<template>
  <div class="search-tabs" v-if="selection">
    <button
      type="button"
      class="search-tab"
      v-on:click="setNewTab(s)"
      :class="{ 'active-type': s.label === selected.label }"
      v-for="s in selection"
    >
      {{ s.label }} ({{ s.numberOfResults }})
    </button>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "SearchTabs",
  computed: {
    ...mapState({
      search: (state) => state.search,
      tabs: (state) => state.search.tabs,
      selected: (state) => state.search.tabs.selected,
      selection: (state) => state.search.tabs.selection,
    }),
  },
  methods: {
    ...mapMutations(["setNewTab"]),
  },
};
</script>

<style scoped>
.search-tabs {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.search-tab {
  margin: 4px 10px;
  padding: 8px 0;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  word-break: keep-all;
  white-space: nowrap;
}

.active-type {
  color: var(--wwfOrange);
  border-bottom-color: var(--wwfOrange);
}
</style>


// WEBPACK FOOTER //
// searchTabs.vue?265e6c22